import type { SearchStoriesSortOrderEnum, StorySortBy } from 'we-tree-api-client/v2';

export type MemoriesSortBy = StorySortBy;
export type MemoriesSortOrder = SearchStoriesSortOrderEnum;

export type MemoriesFilters = {
  query: string;
  familyMemberId: string | null;
  authorUserId: string | null;
  hasAttachments: boolean | null;
  sortBy: MemoriesSortBy;
  sortOrder: MemoriesSortOrder;
};

export const DEFAULT_MEMORIES_FILTERS: MemoriesFilters = {
  query: '',
  familyMemberId: null,
  authorUserId: null,
  hasAttachments: null,
  sortBy: 'createdAt',
  sortOrder: 'desc'
};

export function hasActiveMemoriesFilters(filters: MemoriesFilters): boolean {
  return (
    filters.query.trim().length > 0 ||
    filters.familyMemberId != null ||
    filters.authorUserId != null ||
    filters.hasAttachments != null
  );
}

export const MEMORIES_SORT_OPTIONS: { value: MemoriesSortBy; label: string }[] = [
  { value: 'createdAt', label: 'Date added' },
  { value: 'updatedAt', label: 'Last updated' },
  { value: 'title', label: 'Title' }
];

export function defaultMemoriesSortOrder(sortBy: MemoriesSortBy): MemoriesSortOrder {
  return sortBy === 'title' ? 'asc' : 'desc';
}
